// to do: move to airtable
export const questions = [
    {
        question: "Tell me about yourself",
        category: "Work Experience",
        evaluationStyle: "structured-summary",
        evaluationCriteria: [
            "Length: aim for under 2 minutes.",
            "Use the Present–Past–Future flow: start with current role, then past experience, then future goals.",
            "Past experience: highlight recent, role-relevant achievements and skills, with brief supporting stories.",
            "Evidence: include proven successes or outcomes (metrics optional); volunteer work can support relevance.",
            "Personality: briefly mention a professional-appropriate hobby or interest to break the ice.",
        ],
        introduction:
            "This question offers an opportunity to provide a concise overview of your professional journey. Begin with a brief introduction highlighting your current role and key responsibilities. Keep your answer focused on key accomplishments, and relevant experiences. ",
        content: `
            <div>
                <section style="margin: 10px 0 50px">
                    <div>
                        <strong>"Tell me about yourself"</strong> is often one of the first questions in an interview, and it sets the tone for the rest of the conversation. To make a strong impression, keep your response professional, focused, and tailored to the role you're applying for. Here's how to structure your answer for maximum impact:
                    </div>
                    <ul style="padding-inline-start: 25px">
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Start with a Snapshot of Your Career</strong>
                            <div>Begin with a brief introduction that summarizes your current position, years of experience, and key responsibilities. This gives the interviewer a quick understanding of your professional identity. </div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Highlight Key Achievements</strong>
                            <div>Next, talk about a few standout accomplishments or projects that are relevant to the job you're interviewing for. These should demonstrate your skills, leadership, or problem-solving abilities.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Connect Your Experience to the Role</strong>
                            <div>Tailor your answer by linking your background to the company or role you're applying for. This shows the interviewer that you've thought about how your skills align with the position.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>End with Enthusiasm</strong>
                            <div>Conclude your response by expressing your excitement about the opportunity and the potential to contribute. </div>
                        </li>
                    </ul>
                    <div>
                        By following this structure, you'll provide a clear, confident response that effectively communicates who you are as a professional, while positioning yourself as a strong candidate for the role.
                    </div>
                </section>
                <section style="margin: 5px 0">
                    <strong>Sample answer</strong>
                    <div style="font-style: italic; padding: 20px; margin: 10px 0; background-color: rgba(211, 211, 211, 0.6); border-left: 3px solid darkgrey;">
                        <div style="margin: 10px 0">
                            I’m a software engineer with over six years of experience in developing scalable web applications. Currently, I’m working at XYZ Corporation, where I lead a small team responsible for building and maintaining cloud-based solutions that handle over a million users daily. In my role, I’ve focused on improving application performance, reducing load times by 30%, and implementing modern development practises like CI/CD to streamline the deployment process.
                        </div>
                        <div style="margin: 10px 0">
                            One of my key accomplishments was spearheading the redesign of a core product feature, which resulted in a 25% increase in user engagement and a significant reduction in customer support tickets. I’m particularly proud of how I collaborated with cross-functional teams to identify user pain points and ensure that the new feature addressed them effectively.
                        </div>
                        <div style="margin: 10px 0">
                            What excites me about this role at ABC Inc. is the opportunity to apply my skills in a forward-thinking company that values innovation. I’m eager to bring my expertise in optimizing software solutions and my passion for creating seamless user experiences to your team.
                        </div>
                    </div>
                    <div style="margin: 25px 0 0 0">
                        <strong>Looking for more? </strong><span>Check out these resources.</span>
                        <a href="https://youtu.be/es7XtrloDIQ?si=xvA-foUJmG7xYsFB" target="blank" style="color: #32247b; display: flex; align-items: center; margin: 5px 0"> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-youtube" viewBox="0 0 16 16"><path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"/></svg>
                            <span style="margin: 0 0 0 10px;">
                                <strong>Tell Me About Yourself - Structure a Strong Answer</strong> by Jeff Su
                            </span>
                        </a>
                        <a href="https://youtu.be/es7XtrloDIQ?si=xvA-foUJmG7xYsFB" target="blank" style="color: #32247b; display: flex; align-items: center; margin: 5px 0"> 
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-news" width="16" height="16" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#32247b" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11" />
                                <path d="M8 8l4 0" />
                                <path d="M8 12l4 0" />
                                <path d="M8 16l4 0" />
                            </svg>                            
                            <span style="margin: 0 0 0 10px;">
                                <strong>How to Answer “Tell Me About Yourself” in an Interview</strong> by The Muse
                            </span>
                        </a>
                    </div>
                </section>
            </div>
        `,
    },
    {
        question: "What is your greatest strength?",
        category: "Strengths & Weaknesses",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "Pick a role-relevant strength and state it clearly up front.",
            "Use STAR: describe the situation, your task, actions you took, and the result.",
            "Emphasise your personal contribution and impact, not just the team.",
            "Connect the example to how it benefits this role.",
        ],
        introduction:
            "Choose a strength relevant to the job you're applying for and back it up with a specific example. Connect your strength to the role, highlighting how it will benefit the company and make you a valuable addition to the team. Keep your answer concise, confident, and focused on the value you bring.",
        content: `
            <div>
                <section style="margin: 10px 0 50px">
                    <div>
                        <strong>"What is your greatest strength?"</strong> is an opportunity to showcase a strength that aligns closely with the role you're applying for. Focus on qualities or skills that are directly relevant to the position. Here’s how to answer this question effectively:
                    </div>
                    <ul style="padding-inline-start: 25px">
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Choose a Strength that Relates to the Job</strong>
                            <div>Choose a strength that aligns with the skills and competencies required for the job. This could be a technical skill, problem-solving, or an ability to lead.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Provide Specific Examples</strong>
                            <div>Share examples from your experience where this strength made a difference in your work performance or the success of a project. Use the <a href="https://capd.mit.edu/resources/the-star-method-for-behavioral-interviews/" target="blank" style="text-decoration: underline">STAR method</a> (Situation, Task, Action, Result) to structure your response. </div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Link Your Strength to the Role</strong>
                            <div>Make sure to link your strength to how it will benefit the company in the position you’re applying for. This shows the interviewer that you're aware of the job requirements and are confident you can add value.</div>
                        </li>
                    </ul>
                    <div>By tying your strength to the job at hand, you’re demonstrating that you have what it takes to thrive in the role.</div>
                </section>
                <section style="margin: 5px 0">
                    <strong>Sample answer</strong>
                    <div style="font-style: italic; padding: 20px; margin: 10px 0; background-color: rgba(211, 211, 211, 0.6); border-left: 3px solid darkgrey;">
                        <div style="margin: 10px 0">
                            My greatest strength is my ability to stay organized and manage multiple projects effectively. In my current role as a project manager at XYZ Corp, I oversee a portfolio of five projects at a time, each with its own deadlines and priorities. To ensure nothing falls through the cracks, I use project management tools like Asana and Trello to keep track of tasks, set milestones, and collaborate with cross-functional teams.
                        </div>
                        <div style="margin: 10px 0">
                            For example, last year I managed a high-profile project with a very tight deadline. I created a detailed project plan, delegated responsibilities clearly, and conducted regular check-ins with the team. As a result, we not only met the deadline but also reduced project delivery time by 15%, which helped our client launch ahead of schedule.
                        </div>
                        <div style="margin: 10px 0">
                            I believe my ability to maintain clarity and direction amidst complex projects would allow me to contribute effectively to this role, helping your team deliver on time and within scope.
                        </div>
                    </div>
                    <div style="margin: 25px 0 0 0">
                        <strong>Looking for more? </strong><span>Check out these resources.</span>
                        <a href="https://uk.indeed.com/career-advice/interviewing/what-is-your-greatest-strength-interview-question" target="blank" style="color: #32247b; display: flex; align-items: center; margin: 5px 0"> 
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-news" width="16" height="16" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#32247b" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11" />
                                <path d="M8 8l4 0" />
                                <path d="M8 12l4 0" />
                                <path d="M8 16l4 0" />
                            </svg>                            
                            <span style="margin: 0 0 0 10px;">
                                <strong>What is your greatest strength? Examples and tips for interviews</strong> by Indeed
                            </span>
                        </a>
                    </div>
                </section>
            </div>
        `,
    },
    {
        question: "What is your greatest weakness?",
        category: "Strengths & Weaknesses",
        evaluationStyle: "reflection",
        evaluationCriteria: [
            "Choose a real but non-critical weakness for the role.",
            "Show ownership without over-apologising or over-explaining.",
            "Explain concrete steps taken to improve and current progress.",
            "End with a positive takeaway or ongoing plan.",
        ],
        introduction:
            "Be honest but strategic. Choose a weakness you’ve actively worked on improving, and explain the steps you’re taking to overcome it.",
        content: `
            <div>
                <section style="margin: 10px 0 50px">
                    <div>
                        <strong>"What is your greatest weakness?"</strong> is a challenging question, but it’s an opportunity to demonstrate self-awareness and a commitment to growth. Here’s a framework for answering:
                    </div>
                    <ul style="padding-inline-start: 25px">
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Choose a Real, Yet Manageable Weakness</strong>
                            <div>Pick a weakness that won’t be seen as critical for the role. Avoid overly personal or trivial weaknesses and focus on a professional area you’ve been improving.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Explain How You’re Addressing It</strong>
                            <div>Describe the steps you’ve taken to work on this weakness. Whether it’s seeking feedback, taking courses, or adopting new habits, show that you’re committed to personal growth.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Conclude on a Positive Note</strong>
                            <div>End by reinforcing your progress and showing that you’re a proactive, self-motivated individual.</div>
                        </li>
                    </ul>
                    <div>
                        This response not only acknowledges a weakness but also highlights your ability to overcome challenges and improve your skills.
                    </div>
                </section>
            </div>
        `,
    },
    {
        question: "Tell me about a time when you worked in a team",
        category: "Teamwork & Leadership",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "Set context for the team and goal using STAR structure.",
            "Highlight collaboration actions (communication, coordination, support).",
            "Clarify your role and contributions within the team.",
            "Share the outcome and what made the teamwork effective.",
        ],
        introduction:
            "Teamwork is a core competency for many roles. Provide an example that highlights your ability to collaborate effectively, communicate well, and contribute to a team’s success.",
        content: `
            <div>
                <section style="margin: 10px 0 50px">
                    <div>
                        <strong>"Tell me about a time when you worked in a team."</strong> is an invitation to demonstrate your teamwork skills. Here’s how to craft a compelling response:
                    </div>
                    <ul style="padding-inline-start: 25px">
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Set the Scene</strong>
                            <div>Briefly describe the project or situation, the team, and your role within it. This provides context for your example.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Highlight Your Contributions</strong>
                            <div>Discuss the specific actions you took to collaborate effectively with your team. Focus on communication, leadership, and problem-solving where relevant.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Share the Outcome</strong>
                            <div>Explain the outcome of the project and how your teamwork contributed to its success.</div>
                        </li>
                    </ul>
                    <div>This answer shows your ability to work well with others and contribute to team efforts.</div>
                </section>
            </div>
        `,
    },
    {
        question: "Tell me about a time when you had to manage conflict",
        category: "Conflict & Feedback",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "Describe the conflict briefly and objectively without blaming.",
            "Use STAR to show how you addressed the issue.",
            "Show empathy and focus on resolution over winning.",
            "Share the outcome and what you learned.",
        ],
        introduction:
            "Focus on how you handled the situation professionally, resolved the conflict, and what you learned from the experience.",
        content: `
            <div>
                <section style="margin: 10px 0 50px">
                    <div>
                        <strong>"Tell me about a time you had to manage conflict."</strong> is your opportunity to show maturity and problem-solving skills. Follow these steps for an effective response:
                    </div>
                    <ul style="padding-inline-start: 25px">
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Describe the Conflict</strong>
                            <div>Provide a brief summary of the situation, the people involved, and the nature of the conflict.</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Explain How You Handled It</strong>
                            <div>Walk through the steps you took to resolve the issue. Did you mediate between team members? Did you take a collaborative approach to find a solution?</div>
                        </li>
                        <li type="1" style="margin-bottom: 15px">
                            <strong>Highlight the Outcome</strong>
                            <div>Emphasize how the situation was resolved and what you learned from the experience. This shows your ability to navigate difficult situations constructively.</div>
                        </li>
                    </ul>
                </section>
            </div>
        `,
    },
    {
        question: "Tell me about a time you showed leadership",
        category: "Teamwork & Leadership",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "Describe the leadership moment and why it mattered.",
            "Show initiative and how you influenced others.",
            "Use STAR to explain actions and the result.",
            "Highlight measurable impact on team or outcome.",
        ],
        introduction:
            "Pick a clear example where you influenced others, set direction, or took ownership without needing a formal title. Use the STAR format to give context, then focus on the actions you took and the impact on the team or outcome. Make it clear what you led, how you brought people with you, and what changed because of your leadership.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "Why do you want to work for this company?",
        category: "Company & Role Fit",
        evaluationStyle: "value-alignment",
        evaluationCriteria: [
            "Reference specific company mission, product, or values.",
            "Connect your experience and goals to their needs.",
            "Show understanding of the role and team impact.",
            "Avoid generic praise; be specific and genuine.",
        ],
        introduction:
            "Demonstrate knowledge about the company’s mission, culture, and products. Align the company values to your experience and career goals.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "What are you looking for in your next role?",
        category: "Company & Role Fit",
        evaluationStyle: "value-alignment",
        evaluationCriteria: [
            "Describe the type of work, scope, and growth you want.",
            "Tie your preferences to what this role offers.",
            "Stay positive and avoid listing dislikes from past roles.",
            "Keep it specific and realistic for the position.",
        ],
        introduction:
            "Focus on the type of work, growth, and environment you want, then connect it to this role so it feels specific rather than generic. Mention the kind of problems you enjoy, the skills you want to deepen, and the team culture that helps you perform well. Keep it positive and aligned with what the company offers.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question:
            "Tell me about a time you had a disagreement with your manager",
        category: "Conflict & Feedback",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "Explain the disagreement respectfully and briefly.",
            "Use STAR to show how you communicated and sought alignment.",
            "Highlight professionalism and focus on shared goals.",
            "Share the outcome and what you learned.",
        ],
        introduction:
            "Share a respectful disagreement that shows maturity and professional judgment, not conflict for its own sake. Emphasise how you communicated, sought alignment, and worked towards a solution that served the wider goals. The key is to show you can disagree thoughtfully while maintaining trust.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "Tell me about a time you met a tight deadline",
        category: "Time & Delivery",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "State the deadline and why it was challenging.",
            "Use STAR to explain your plan and actions.",
            "Show prioritization, trade-offs, and communication.",
            "Share the result and any lessons learned.",
        ],
        introduction:
            "Highlight how you prioritised, communicated, and delivered under pressure when time was limited. Include what the deadline was, what trade-offs you made, and how you kept stakeholders informed. End with the result and what you learned about working at pace.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "Why are you a good fit for the position?",
        category: "Company & Role Fit",
        evaluationStyle: "structured-summary",
        evaluationCriteria: [
            "Lead with 2-3 role-matching strengths or experiences.",
            "Back each claim with evidence or brief examples.",
            "Connect to team needs and desired outcomes.",
            "Keep it concise and confident.",
        ],
        introduction:
            "Match your skills, experience, and values to the role’s requirements rather than repeating your CV. Use one or two concrete examples to show impact, then connect those examples directly to what the team needs. Keep it confident and specific, with a clear link to the role.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "What excites you about the role?",
        category: "Company & Role Fit",
        evaluationStyle: "value-alignment",
        evaluationCriteria: [
            "Name specific responsibilities or challenges you enjoy.",
            "Explain why they match your strengths and goals.",
            "Show you understand the role’s scope and impact.",
            "Avoid vague enthusiasm; keep it concrete.",
        ],
        introduction:
            "Mention the specific responsibilities or challenges that energise you, and explain why they align with your strengths and goals. Show that you understand what the role involves and how it fits your longer-term direction. Avoid generic enthusiasm and be precise about what draws you in.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "Where do you want to be in five years?",
        category: "Career & Growth",
        evaluationStyle: "reflection",
        evaluationCriteria: [
            "Describe a realistic trajectory aligned with the role.",
            "Focus on skills to build and impact to make.",
            "Show flexibility rather than rigid plans.",
            "Link your growth to the company’s opportunities.",
        ],
        introduction:
            "Show ambition and realism by describing a trajectory that fits the role and the company’s growth. Emphasise the skills you want to build, the type of impact you want to make, and how this role is a logical next step. Keep it flexible rather than overly fixed.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "Tell me about your past projects",
        category: "Work Experience",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "Select 1-2 relevant projects and give brief context.",
            "Use STAR to outline your role and key actions.",
            "Emphasize decisions, trade-offs, and results.",
            "Tie the project skills to the role you want.",
        ],
        introduction:
            "Choose one or two relevant projects rather than listing everything. Explain your role, the goal, key decisions you made, and the measurable results. Use the project to highlight skills that matter for this role and keep the story focused.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "How do you stay up to date with the ever-changing industry?",
        category: "Work Experience",
        evaluationStyle: "reflection",
        evaluationCriteria: [
            "Name specific sources or routines you use consistently.",
            "Explain how you filter and apply what you learn.",
            "Show curiosity and practical impact on your work.",
            "Avoid a long list; keep it focused and credible.",
        ],
        introduction:
            "Share concrete habits like newsletters, courses, communities, or experiments that you genuinely use. Explain how you filter what matters and apply it at work rather than just consuming content. This shows curiosity as well as practical impact.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "Tell me about a time you failed to meet a deadline",
        category: "Time & Delivery",
        evaluationStyle: "reflection",
        evaluationCriteria: [
            "Be honest about the miss without excessive detail.",
            "Explain root cause and your accountability.",
            "Share changes you made to prevent repeats.",
            "End with lessons learned and improved outcomes.",
        ],
        introduction:
            "Be honest and concise about what happened, without over-explaining. Focus on the root cause, what you learned, and what you changed to prevent it in the future. The goal is to show accountability and growth.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question:
            "Tell me about a time you received constructive criticism. How did you handle it?",
        category: "Conflict & Feedback",
        evaluationStyle: "reflection",
        evaluationCriteria: [
            "Describe the feedback briefly and objectively.",
            "Show openness and how you responded.",
            "Explain actions taken and measurable improvement.",
            "Keep tone mature and solutions-focused.",
        ],
        introduction:
            "Show openness to feedback by describing the criticism, your response, and the improvement that followed. Emphasise how you reflected, took action, and measured progress. Keep the tone mature and solutions-focused.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    {
        question: "Describe a time when you had to make a difficult decision",
        category: "Strengths & Weaknesses",
        evaluationStyle: "STAR",
        evaluationCriteria: [
            "Provide context and the key trade-offs involved.",
            "Use STAR to show your decision process and actions.",
            "Highlight stakeholders and how you balanced priorities.",
            "Share the outcome and what you learned.",
        ],
        introduction:
            "Walk through the context, the trade-offs, and how you decided. Emphasise your reasoning, the stakeholders involved, and the impact of the choice. The interviewer wants to see judgement under pressure.",
        content: `
            <div>[Insert '[Add question]' content]</div>
        `,
    },
    // {
    //     question: "",
    //     category: "",
    //     introduction: "",
    //     content: `
    //         <div>[Insert '[Add question]' content]</div>
    //     `,
    // },
];
